export default {
  PAGE_NAME_INPUT: 'page-name-input-field',
  PAGE_TEMPLATE_SELECT: 'page-template-select-field',
  DISPLAY_IN_NAVIGATION_CHECKBOX: 'display-in-navigation-checkbox-field',
  USER_INPUT: 'user-input-field',
  TRANSLATE_LOCALES: 'locales',
  TRANSLATE_PAGE_IDS: 'pageIds',
  TRANSLATE_AUTO_TRANS: 'autoTrans',
  EXISTING_PAGE_RESOLVING: 'existingPageResolving',
};
